/**
 * The different statuses a Stripe Invoice can be
 */
// eslint-disable-next-line import/prefer-default-export
export enum InvoiceStatus {
  DRAFT = 'draft',
  OPEN = 'open',
  UNCOLLECTIBLE = 'uncollectible',
  PAID = 'paid',
  VOID = 'void',
}
